/**
 * 设置状态模块
 * @description 管理应用设置，包括工作台模式等
 */
const setting = {
  namespaced: true,
  state: {
    homeViewResetCount: 0
  },
  mutations: {
    RESET_HOME_VIEW: (state) => {
      state.homeViewResetCount++
    }
  },
  actions: {},
  getters: {}
}

export default setting
